import firebase from '../authentication/firebaseStart';

class DevicesSummaryCountDataService {
  
  getAll(_stValue, _companyID ) {
    let siteValue = _stValue === 'AllSites' ? "All Devices" : _stValue
    return firebase.database().ref(`/tenants/${_companyID}/SummaryCount/${siteValue}`)
    
  }
}

export default new DevicesSummaryCountDataService();
